<template>
  <ui-dialog
    :show="isOpen"
    max-width="623"
    @input="handleClose"
    class="manage-reply-template"
  >
    <template #header>
      <div class="manage-reply-template__header">
        <h3 v-if="mode">
          {{ $t(`message.reviews.replyTemplates.templates.${mode}`) }}
        </h3>
      </div>
    </template>

    <div class="manage-reply-template__body">
      <v-textarea
        v-model="templateText"
        ref="input"
        :label="
          $t('message.reviews.replyTemplates.templates.templateTextPlaceholder')
        "
        clearable
        class="manage-reply-template__textarea"
        :hide-details="true"
      ></v-textarea>
    </div>

    <template #actions>
      <div class="w-100 d-flex justify-center">
        <ui-button
          @click="clearTemplateText"
          class="mr-2"
          :disabled="!templateText"
          color="primary"
          outlined
          min-width="130"
        >
          {{ $t("message.common.clear") }}
        </ui-button>
        <ui-button
          @click="handleSave"
          class="ml-2"
          :disabled="!templateText"
          color="primary"
          min-width="130"
        >
          {{ $t("message.common.save") }}
        </ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import { DIALOG_MANAGE_MODE } from "@/enums/reply-templates";

export default {
  name: "ReplyTemplatesManageTemplateDialog",

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    templateToEdit: {
      validator: val => ["object", "null"].includes(typeof val)
    },
    mode: {
      type: String,
      default: DIALOG_MANAGE_MODE.ADD,
      validator: val =>
        [DIALOG_MANAGE_MODE.ADD, DIALOG_MANAGE_MODE.EDIT].includes(val)
    }
  },

  data() {
    return {
      templateText: ""
    };
  },

  watch: {
    async isOpen(newValue) {
      if (newValue) {
        if (this.templateToEdit && this.templateToEdit.text) {
          this.templateText = this.templateToEdit.text;
        }
        setTimeout(() => {
          this.$refs.input.focus();
        }, 100);
      } else {
        this.templateText = "";
      }
    }
  },

  methods: {
    handleSave() {
      if (!this.templateText) return;

      if (this.mode) {
        const modeHandlers = {
          add: () => {
            this.$emit("save", this.templateText);
          },
          edit: () => {
            const editedTemplate = {
              ...this.templateToEdit,
              text: this.templateText
            };
            this.$emit("edit", editedTemplate);
          }
        };
        modeHandlers[this.mode]();
      }
      this.handleClose();
    },
    clearTemplateText() {
      this.templateText = "";
      setTimeout(() => {
        this.$refs.input.focus();
      }, 100);
    },
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.manage-reply-template {
  &__header {
    flex: 1 1 auto;
    text-align: center;
    margin-left: $spacing * 2.5;
  }

  &__body {
    padding: $spacing * 2.5 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__textarea {
    min-width: 100%;
  }
}
</style>
